import { render } from "./DetailTextModal.vue?vue&type=template&id=89399616&scoped=true"
import script from "./DetailTextModal.vue?vue&type=script&lang=js"
export * from "./DetailTextModal.vue?vue&type=script&lang=js"

import "./DetailTextModal.vue?vue&type=style&index=0&id=89399616&scoped=true&lang=css"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89399616"]])

export default __exports__